import { Action, ResourceType } from '../../../../typings/permissions';
import useOrganizationQuickImportScanMethodsSettings from '../../../hooks/api/organization/useOrganizationQuickImportScanMethodsSettings';
import { useHasPermission } from '../../../shared/permissions';

import ModalQuickImportScanMethods from './ModalQuickImportScanMethods';
import type { ScanMethodSelections } from './types';

type Props = {
  organizationId: number;
  isOpen: boolean;
  onBack: () => void;
  onConfirm: (selections: ScanMethodSelections) => void;
};

/**
 * Import flow reactive entry point for scan method selection.
 * Responsible for fetching the organization's default quick import scan method settings
 * and checking if the user has permission to save preferences, then passing that information
 * to the display-only ModalQuickImportScanMethods component.
 */
const QuickImportScanMethodsOptions = (props: Props) => {
  const { data } = useOrganizationQuickImportScanMethodsSettings(
    props.organizationId,
    props.isOpen,
  );
  const hasPermission = useHasPermission();

  if (!props.isOpen || !data) {
    return null;
  }

  const canSavePreference = hasPermission({
    resourceType: ResourceType.OrganizationGeneralSettings,
    action: Action.Edit,
  });

  return (
    <ModalQuickImportScanMethods
      show
      onBack={props.onBack}
      onConfirm={props.onConfirm}
      defaultVendoredEnabled={data.projectDefaultQuickImportVendoredDetectionEnabled ?? false}
      defaultSnippetEnabled={data.projectDefaultQuickImportSnippetDetectionEnabled ?? false}
      canSavePreference={canSavePreference}
    />
  );
};

export default QuickImportScanMethodsOptions;
